import * as React from "react";
import DataLakeCell from "./components/DataLakeCell";
const dataLakeCustomColumnRenderer = {
  data_lake: {
    renderCell: (_data_lake, stream) => /* @__PURE__ */ React.createElement(DataLakeCell, { stream }),
    staticWidth: "matchHeader"
  }
};
export default dataLakeCustomColumnRenderer;
